import { http } from '@/http/axios.js'

// 门店员工分页列表
export function getListAPI(params) {
  return http({
    url: '/admin/store/employee/page',
    method: 'get',
    params
  })
}

// 设置新密码
export function setPasswordAPI(data) {
  return http({
    url: '/admin/store/employee/password/set',
    method: 'post',
    data
  })
}

// 随机生成密码（后端生成）
export function generatePasswordAPI() {
  return http({
    url: '/admin/store/employee/password/generate',
    method: 'get'
  })
}
